const VOIDED_CANCEL_STATUSES = ['VOIDED', 'CANCELLED', 'CANCELED'];

export { VOIDED_CANCEL_STATUSES };
